<template>
    <div>
        <div>
            <MobileHeader active="job"></MobileHeader>
            <div class="swiper-container">
                <h1>人才招聘</h1>
            </div>
            <div class="padding-top" >
                <div style="width:100%;height: 25rem;">
                    <img src="../../assets/imgs/jobs/job_bg.jpg" style="display: inline-block; width: 100%; max-width: 100%; height: 150px;">
                </div>
                <div style="margin-top: -253px;">
                    <i class="el-icon-caret-top" style="font-size: 90px;margin-top: -50px;color: white;"></i>
                    <img src="../../assets/imgs/jobs/team.jpg" style="display: inline-block; width: 100%; max-width: 100%; height: 150px;">
                </div>
            </div>

            <div>
                <div v-for="(item, index) in list" v-bind:key="item.id" v-bind:class="{'bg-grey': (index + 1) % 2 === 0}">
                    <div class="padding-left-lg padding-bottom-lg "  @click="toDetail(item.id)">
                        <div class="job-title">
                            <span class="text-black span-title" >{{item.title}}</span>
                            <span class="text-date"> {{convertTime(item.createTime)}}</span>
                        </div>
                        <div class="text-df">
                            <span class="job-hiden" style="width: 90%;margin-right: 15px;">{{item.summary}}</span>
                        </div>
                    </div>
                </div>
            <!--    <scroller style="top: 450px;" height='400' :on-refresh="refresh" ref="myscroller">
                    <div v-for="(item, index) in list" v-bind:key="item.id" v-bind:class="{'bg-grey': (index + 1) % 2 === 0}">
                        <div class="padding-left-lg padding-bottom-lg ">
                            <div class="job-title">
                                <span class="text-black span-title">{{item.title}}</span>
                                <span class="text-date"> {{convertTime(item.createTime)}}</span>
                            </div>
                            <div class="text-df">
                                <span class="job-hiden" style="width: 100%;">{{item.summary}}</span>
                            </div>
                        </div>
                    </div>
                </scroller>-->
            </div>

        </div>
        <MobileFooter></MobileFooter>
    </div>
    
</template>

<script>
    import MobileHeader from "../../components/MobileHeader";
    import {jobApi} from "../../api/job-api";
    import {formatFromTimeString} from "../../utils/date";
    import MobileFooter from "../../components/MobileFooter";

    export default {
        name: "MobileHome",
        components: {MobileFooter,MobileHeader},
        data () {
            return {
                page: 1,
                limit: 30,
                totalPage: 1,
                list: []
            }
        },
        mounted () {
            this.listNews();
        },
        methods: {
            listNews () {
                jobApi.list({
                    status: 1,
                    page: this.page,
                    limit: this.limit
                }).then(res => {
                    if (res.code === 200) {
                        this.totalPage = res.page.totalPage;
                        this.list = res.page.list;
                    }
                })
            },
            refresh(done) {
                console.log("refresh");
                this.page =  this.page +1;
               this.listNews();
                done();
            },
            toDetail (id) {
                this.$router.push({
                    path: `/detail/${id}`,
                    query: {
                        active: 'job'
                    }
                })
            }
        },
        computed: {
            convertTime () {
                return function (time) {
                    return formatFromTimeString(time);
                }
            }
        }
    }
</script>

<style scoped>
    .swiper-container {
        width: 100%;
      /*  padding-top: 15px;*/
    }
    .job-hiden{
        font-size: 15px;
        margin-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        color: black ;
    }
    .job-title{
        font-size: 20px;
        padding-top:10px;
        padding-bottom: 35px;
    }
    .backgroundcolor .text-black{
        background-color: rgb(0, 153, 255) !important ;
    }
    .cu-item.arrow:hover{
        background-color: rgb(0, 153, 255) !important ;
    }
    .cu-item.arrow:hover .text-black{
        color: white;
    }
    .header-text{
        text-align: center;
        font-size: 20px ;
    }
    .padding-top{
        padding-top: 10px;
    }
    .text-date{
        float: right;
        font-size: 14px;
        color: grey;
        margin-right: 20px;
    }
    .padding-left-lg:active {
        background: #ff4e00;
    }
    .padding-left-lg {
        padding-left: 10px;
    }
    .padding-bottom-lg {
        padding-bottom: 10px;
    }
    .span-title{
        float: left;
        margin-left: 10px;
        font-weight: bold;
    }
    .bg-grey{
        background-color: rgb(233 231 231);
    }
</style>
